<template>
  <div id="app">
		<Header />
    <router-view/>
		<Footer />
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
export default {
	name: 'app',
	components: {
		Header,
		Footer
  }
}
</script>
<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Noto+Sans+JP:400,700&display=swap&subset=japanese'); //noto sans JP

@import url('https://fonts.googleapis.com/css?family=Pathway+Gothic+One&display=swap');

@font-face {
	font-family: 'Noto Serif Japanese';
	font-style: normal;
	font-weight: 400;
	src: url('assets/fonts/NotoSerifCJKjp_subset/NotoSerifCJKjp-Regular.otf') format('opentype'),
	url('assets/fonts/NotoSerifCJKjp_subset/NotoSerifCJKjp-Regular.woff') format('woff');
}
@font-face {
	font-family: 'Noto Serif Japanese';
	font-style: bold;
	font-weight: 600;
	src: url('assets/fonts/NotoSerifCJKjp_subset/NotoSerifCJKjp-SemiBold.otf') format('opentype'),
	url('assets/fonts/NotoSerifCJKjp_subset/NotoSerifCJKjp-SemiBold.woff') format('woff');
}

#app {
  font-family: 'Noto Sans JP', sans-serif '游ゴシック体', YuGothic, '游ゴシック', 'Yu Gothic', 'メイリオ', sans-serif;
  font-weight: 700;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333333;
	line-height: 2em;
}

//normalize
html {
	// font-family: sans-serif;
	-webkit-text-size-adjust: 100%;
	-ms-text-size-adjust:     100%;
}
body {
	margin: 0;
}
article,
aside,
details,
figcaption,
figure,
footer,
header,
main,
menu,
nav,
section,
summary {
	display: block;
}
audio,
canvas,
progress,
video {
	display: inline-block;
	vertical-align: baseline;
}
audio:not([controls]) {
	display: none;
	height: 0;
}
[hidden],
template {
	display: none;
}
abbr[title] {
	border-bottom: 1px dotted;
}
b,
strong {
	font-weight: bold;
}
dfn {
	font-style: italic;
}
h1 {
	font-size: 2em;
	margin: 0.67em 0;
}
mark {
	background: #ff0;
	color: #000;
}
small {
	font-size: 80%;
}
sub,
sup {
	font-size: 75%;
	line-height: 0;
	position: relative;
	vertical-align: baseline;
}
sup {
	top: -0.5em;
}
sub {
	bottom: -0.25em;
}
img {
  border: 0;
  max-width: 100%;
  height: auto;
}
svg:not(:root) {
	overflow: hidden;
}
figure {
	margin: 1em 40px;
}
hr {
	box-sizing: content-box;
	height: 0;
}
pre {
	overflow: auto;
}
code,
kbd,
pre,
samp {
	font-family: monospace, monospace;
	font-size: 1em;
}
button,
input,
optgroup,
select,
textarea {
	color: inherit;
	font: inherit;
	margin: 0;
}
button {
	overflow: visible;
	border-color: inherit;
	&:focus {
		outline: none;
	}
}
button,
select {
	text-transform: none;
}
button,
html input[type="button"],
input[type="reset"],
input[type="submit"] {
	-webkit-appearance: button;
	cursor: pointer;
}
button[disabled],
html input[disabled] {
	cursor: default;
}
button::-moz-focus-inner,
input::-moz-focus-inner {
	border: 0;
	padding: 0;
}
input {
	line-height: normal;
}
input[type="checkbox"],
input[type="radio"] {
	box-sizing: border-box;
	padding: 0;
}
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
	height: auto;
}
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-decoration {
	-webkit-appearance: none;
}
fieldset {
	border: 1px solid #c0c0c0;
	margin: 0 2px;
	padding: 0.35em 0.625em 0.75em;
}
legend {
	border: 0;
	padding: 0;
}
textarea {
	overflow: auto;
}
optgroup {
	font-weight: bold;
}
table {
	border-collapse: collapse;
	border-spacing: 0;
}
td,
th {
	padding: 0;
}
ul {
	list-style: none;
	margin: 0;
	padding: 0;
}
ol {
	margin: 1em;
	padding: 0;
}
p {
	// letter-spacing: 0.1em;
}
a {
  background-color: transparent;
	color: inherit;
	text-decoration: none;
	transition: 0.2s;
}
a:not([href^="tel"]):not(.comingsoon):hover {
	@media print, screen and (min-width: 769px) {
		opacity: 0.5;
	}
}
 a[href^="tel"] {
	cursor: default;
	text-decoration: none;
}
.clear:after {
  content: "";
  display: block;
  clear: both;
}
.mincho {
  font-family: 'Noto Serif Japanese', serif;
  letter-spacing: 0.05em;
  // font-weight: 600;
}
.Longfont {
	font-family: 'Pathway Gothic One', sans-serif;
}
.over_display {
	display: block;
	@media print, screen and (max-width: 414px) {
    display: none;
  }
}
.under_display {
	display: none;
	@media print, screen and (max-width: 414px) {
    display: block;
  }
}
</style>
